// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2y8my","footer":"ReportModalFilter_footer__20QtC"};